import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { CognitoUserProvider } from '../contexts/cognitoUserContext';
import { StripeProvider } from '../contexts/stripeContext';

/**
 * AuthProvider - Consolidates all authentication and payment-related context providers
 * Includes: Amplify Authenticator (context only), Cognito User, Stripe
 */
export function AuthProvider({ children }) {
  return (
    <CognitoUserProvider>
      <Authenticator.Provider>
        <StripeProvider>
          {children}
        </StripeProvider>
      </Authenticator.Provider>
    </CognitoUserProvider>
  );
}
